import { UzButton, UzDialog } from '@utazzo/ui';
import React, { useState } from 'react';

import { useChallanList } from '../use-tcs-challans';

import { formatDMY } from '@/lib/date-format';

interface TcsAddToChallanDialogProps {
  open: boolean;
  invoiceCount: number;
  pending?: boolean;
  onConfirm: (challanId: string) => void;
  onCancel: () => void;
}

/** Pick an existing challan to add the selected invoices to. */
export const TcsAddToChallanDialog = ({
  open,
  invoiceCount,
  pending,
  onConfirm,
  onCancel,
}: TcsAddToChallanDialogProps): React.JSX.Element => {
  const list = useChallanList(undefined, open);
  const [picked, setPicked] = useState<string | null>(null);
  const challans = list.data ?? [];

  return (
    <UzDialog
      open={open}
      onOpenChange={(o) => {
        if (!o) onCancel();
      }}
      title="Add to existing challan"
      description={`Choose the challan to add ${invoiceCount} selected invoice${invoiceCount === 1 ? '' : 's'} to.`}
      size="md"
      footer={
        <div className="flex justify-end gap-2">
          <UzButton variant="ghost" onClick={onCancel}>
            Cancel
          </UzButton>
          <UzButton
            loading={pending}
            disabled={!picked}
            onClick={() => picked && onConfirm(picked)}
          >
            Add to challan
          </UzButton>
        </div>
      }
    >
      {list.isLoading ? (
        <p className="text-sm text-zinc-500">Loading challans...</p>
      ) : challans.length === 0 ? (
        <p className="text-sm text-zinc-500">No challans yet. Create one instead.</p>
      ) : (
        <ul className="divide-y divide-zinc-100 rounded-lg border border-zinc-200">
          {challans.map((c) => (
            <li key={c.id}>
              <label className="flex cursor-pointer items-center gap-3 px-3 py-2">
                <input
                  type="radio"
                  name="tcs-challan-pick"
                  checked={picked === c.id}
                  onChange={() => setPicked(c.id)}
                />
                <span className="text-sm text-zinc-800">
                  {c.challanNo ?? 'No challan no.'}
                  <span className="ml-2 text-xs text-zinc-500">
                    {c.challanDate ? formatDMY(c.challanDate) : 'No date'} - {c.invoiceCount}{' '}
                    invoice{c.invoiceCount === 1 ? '' : 's'} - {c.paid ? 'Paid' : 'Unpaid'}
                  </span>
                </span>
              </label>
            </li>
          ))}
        </ul>
      )}
    </UzDialog>
  );
};
